import { render } from "./PublicPledgeMaking.vue?vue&type=template&id=c8048462&scoped=true"
import script from "./PublicPledgeMaking.vue?vue&type=script&lang=js"
export * from "./PublicPledgeMaking.vue?vue&type=script&lang=js"

import "./PublicPledgeMaking.vue?vue&type=style&index=0&id=c8048462&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8048462"]])

export default __exports__